import {useProductReview} from '../../../context/ProductReviewContext'
import {ProductReviewField} from '../../ui/ProductReviewField'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {PRODUCT_REVIEW_DISPLAY_INFORMATION_SECTION} from '../productReviewDataMap'

/**
 * @param {{language: {code: string, language: string}}} props
 */
export const DisplayLanguageSection = ({language}) => {
  const {productData, updateEditableField} = useProductReview()

  return (
    <ProductReviewSection title={`Language: ${language.language}`}>
      <div className="divide-y divide-[var(--secondary-800)]">
        {PRODUCT_REVIEW_DISPLAY_INFORMATION_SECTION.fields.map(field => {
          const sourceData = productData?.[field.source] ?? {}
          const value = sourceData?.[field.key]?.[language.code]

          return (
            <div key={`${language.code}-${field.key}`}>
              <ProductReviewField
                label={field.label}
                labelKey={field.key}
                editable={field.editable}
                required={field.required}
                renderer={field.renderer}
                value={value}
                onChange={nextValue => updateEditableField(field.source, field.key, nextValue, language.code)}
              />
            </div>
          )
        })}
      </div>
    </ProductReviewSection>
  )
}
